import './assets/Dropdown.css';const o = "_dropdown_1xktc_7", d = {
  "dropdown-trigger": "_dropdown-trigger_1xktc_7",
  dropdown: o,
  "dropdown-item": "_dropdown-item_1xktc_31"
};
export {
  d as s
};
